import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const sitemapGenerate = (provider: string) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:generate`, 
        category: settings.categoryName 
    });
};

export default sitemapGenerate;